let StringUtils = {
    splice: (str,len) => {
        return str.length > len ? str.substring(0, len) + '...' : str;
    },
    replacePngToJpg(str){
        return str.replace("=png","=jpg");
    }
};
export default StringUtils;